module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __limited-edu __limited-edu--uob __uob-heartbeat-2024 __uob-heartbeat-2024--foldable-bag"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10"
  }, [_c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper mt-15 mb-15"
  }, [_c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg"
  }, [_vm._v("\n                  ไม่ต้องการรับของที่ระลึก\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.attributes.info.rewardProduct, "")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", "")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('label', {
    staticClass: "form__radio-lg",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.rewardTitleText) + " "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardProduct),
      expression: "attributes.info.rewardProduct"
    }],
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "disabled": _vm.isRewardDisabled
    },
    domProps: {
      "value": _vm.tshirtProductName,
      "checked": _vm._q(_vm.attributes.info.rewardProduct, _vm.tshirtProductName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.attributes.info, "rewardProduct", _vm.tshirtProductName)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTakeReward),
      expression: "isTakeReward"
    }],
    staticClass: "slide-down-wrapper",
    class: {
      disable: _vm.isRewardDisabled
    }
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--lmt-deu"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "current-thumbnail-wrapper",
    on: {
      "click": function($event) {
        return _vm.showImage(_vm.currentThumbnailImage)
      }
    }
  }, [_c('img', {
    staticClass: "ma-auto d-block mb-10",
    attrs: {
      "src": _vm.currentThumbnailImage,
      "alt": "Limited Education"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row mb-10 d-flex justify-content-center"
  }, _vm._l((_vm.thumbnailImages), function(thumbnail, i) {
    return _c('div', {
      key: i,
      staticClass: "col-sm-4 col-md-3"
    }, [_c('div', {
      staticClass: "thumbnail-wrapper",
      class: {
        selected: thumbnail === _vm.currentThumbnailImage
      },
      on: {
        "click": function($event) {
          return _vm.changeThumbnail(thumbnail)
        }
      }
    }, [_c('img', {
      staticClass: "ma-auto d-block",
      attrs: {
        "src": thumbnail,
        "alt": "Limited Education"
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-10"
  }, [_c('strong', [_vm._v("ระบุจำนวน")]), _vm._v(" "), _c('strong', {
    staticClass: "choice-selected"
  }, [_vm._v(_vm._s(_vm.selectedSizeCount) + "/" + _vm._s(_vm.rewardCount))])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-size-choice"
  }, [_vm._l((_vm.sizeOptions), function(sizeOption) {
    return _c('div', {
      key: sizeOption.text,
      staticClass: "size-choice",
      class: {
        active: _vm.hasSelectedSize(sizeOption.text),
        'only-one': _vm.rewardCount === 1
      },
      on: {
        "click": function($event) {
          return _vm.selectSize(sizeOption.text)
        }
      }
    }, [_c('label', {}, [_vm._v(_vm._s(sizeOption.text))]), _vm._v(" "), _c('div', {
      staticClass: "text-remark"
    }, [_vm._v(_vm._s(sizeOption.description))]), _vm._v(" "), _c('div', {
      staticClass: "number-field"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.decreaseSize(sizeOption.text)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), _c('span', {
      staticClass: "number-item"
    }, [_vm._v(_vm._s(_vm.selectedSize[sizeOption.text]))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.increaseSize(sizeOption.text)
        }
      }
    }, [_vm._v("+")])])])
  }), _vm._v(" "), (_vm.error.rewardConfigSize) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v(_vm._s(_vm.error.rewardConfigSize))]) : _vm._e()], 2)])])])])])])])], 1)]), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "alert alert--warning"
  }, [_vm._v("โปรดตรวจสอบข้อมูลให้ถูกต้องก่อนกดปุ่มสั่งของที่ระลึก")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("กดเพื่อบริจาค/ชำระเงิน")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-2 col-md-8"
  }, [_c('div', {
    staticClass: "text-center mb-10"
  }, [_c('img', {
    staticClass: "logo pd-15 ma-auto d-block",
    attrs: {
      "src": "/static/img/uob/uob-limited-education.png",
      "srcset": "/static/img/uob/uob-limited-education.png",
      "alt": "TCFE x UOB x Limited Education"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "page-title text-center"
  }, [_vm._v("UOB x Limited Education 2024"), _c('br'), _vm._v("การศึกษาสร้างอนาคตที่สดใสให้เด็กไทย")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-title text-center"
  }, [_vm._v("กระเป๋าคลัชใส่ iPad")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center mt-15"
  }, [_c('div', {
    staticClass: "alert alert--info"
  }, [_vm._v("สินค้าที่ระลึกเป็นรูปแบบสั่งจองล่วงหน้า จะจัดส่งให้ได้ในช่วงเดือนกันยายน 2567 เป็นต้นไป")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa75f90","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/uob-lmtedu-2024-public-clutch-bag.vue
// module id = 1188
// module chunks = 0